function HeadsetIcon({color = '#fff'}: { color?: string }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 13v-1a8 8 0 0 1 16 0v1" />
            <path d="M20 14v3a3 3 0 0 1-3 3h-3" />
            <rect x="2.5" y="13" width="4" height="6" rx="1.5" />
            <rect x="17.5" y="13" width="4" height="6" rx="1.5" />
        </svg>
    );
}

export default HeadsetIcon;
